import React, {FormEvent, useCallback, useEffect, useState} from 'react';

import {useHistory, useParams} from 'react-router-dom';
import ReactPaginate from 'react-paginate';

import SiteWrapper from "../../base/SiteWrapper";

import {Button, Card, Form, Page, Table, Text} from "tabler-react";

import {ApiFidegg} from "../../services/apiFideggAdmin";
import {Alerta} from "../../utils/Alerta";
import CashbackStatement, {
  StatementStatusEnum,
  StatementStatusMap,
  StatementTypeEnum,
  StatementTypeMap
} from "../../interfaces/CashbackStatement";
import Params from "../../interfaces/Params";
import Customer from "../../interfaces/Customer";
import {formatDateToDDMMYYYY} from "../../utils/formatDate";
import {formatMoney} from "../../utils/formatMoney";

interface CashbackStatementParams extends Params {
  customer_id: any
}

function CashbackStatementsList() {

  const history = useHistory();

  const { customer_id } = useParams<CashbackStatementParams>();

  const [customer, setCustomer] = useState<Customer>();
  const [statements, setStatements] = useState([]);
  const [page, setPage]= useState(1);
  const [pageCount, setPageCount]= useState(0);

  useEffect(() => {
    updateTransactionsList();
  }, [page]);

  async function updateTransactionsList() {
    const params = {
      page,
      customer_id: customer_id,
    };

    await ApiFidegg.get('cashbackstatements', { params }).then(response => {
      setStatements(response.data.statements);
      setPageCount(response.data.pages);
    });

    await ApiFidegg.get(`customers/${customer_id}`).then(response => {
      setCustomer(response.data);
    });
  }

  function handleEditClick(statement: CashbackStatement) {
    history.push(`/customers/cashback-statement/${customer_id}/form`);
  }

  function handleClickAdd() {
    history.push(`/customers/cashback-statement/${customer_id}/form`);
  }

  const handlePaginate = useCallback((selectedItem: { selected: number }) => {
    setPage(selectedItem.selected + 1);
  }, []);

  const handleUpdateClick = useCallback(
    async (statement: CashbackStatement, status: StatementStatusEnum) => {
      const type = statement.type === StatementTypeEnum.INCOME ? 'Crédito' : 'Resgate';
      const action = status === StatementStatusEnum.ACTIVE ? 'reativar' : 'cancelar';
      try {
        if(window.confirm(`Deseja ${action} o ${type}?`)) {
          await ApiFidegg.put(`cashbackstatements/${statement.id}`, { status });

          Alerta(`Sucesso ao ${action} ${type}!`, "success");
          updateTransactionsList();
        }
      } catch (err) {
        Alerta(`Não foi possível ${action} ${type}!`);
      }
  }, []);

  return (
    <SiteWrapper>
      <Page.Content>
        <Card>
          <Card.Header>
            <Card.Title>Histórico de Cashback</Card.Title>
            <Card.Options>
              <Button RootComponent="a" color="secondary" size="sm" icon="plus" onClick={handleClickAdd}>
                Incluir
              </Button>
            </Card.Options>
          </Card.Header>


          {customer && (
            <Card.Header>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "0 4px",
                  fontSize: "15px",
                  width: "100%",
                }}
              >
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <span><strong>Cliente:</strong> {customer.name} {customer.surname}</span>
                  <span><strong>Email:</strong> {customer.email}</span>
                </div>

                <div style={{ fontWeight: "bold", fontSize: "18px" }}>
                  {Number(customer.points_balance).toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL"
                  })}
                </div>
              </div>
            </Card.Header>
          )}

          <Table
            responsive
            className="card-table table-vcenter text-nowrap"
            headerItems={[
              { content: "Data"},
              { content: "Operação" },
              { content: "Expira em" },
              { content: "Valor" },
              { content: "Descrição" },
              { content: null },
            ]}
            bodyItems={statements.map((s: CashbackStatement) => ({
              key: s.id,
              className: "statement_row",
              item: [
                { content: <Text>{formatDateToDDMMYYYY(s.created_at)}</Text> },
                { content: <Text>{StatementTypeMap.get(s.type)}</Text> },
                { content: <Text>{s.expiration_date ? formatDateToDDMMYYYY(s.expiration_date) : ''}</Text> },
                { content: <Text>{formatMoney(s.value.toString())}</Text> },
                { content: <Text>{s.description}</Text> },
                {
                  alignContent: "right",
                  content: s.manually && (
                    <Button
                      RootComponent="a"
                      color="secondary"
                      size="sm"
                      className="m-1"
                      icon={s.status === StatementStatusEnum.ACTIVE ? "minus" : "plus"}
                      onClick={() =>
                        handleUpdateClick(
                          s,
                          s.status === StatementStatusEnum.ACTIVE
                            ? StatementStatusEnum.CANCELED
                            : StatementStatusEnum.ACTIVE
                        )
                      }
                    />
                )
                },
              ]
            }))}
          />
          <Card.Footer>
            <ReactPaginate
              previousLabel={'<'}
              nextLabel={'>'}
              breakLabel={"..."}
              breakClassName={"break-me"}
              pageCount={pageCount}
              marginPagesDisplayed={1}
              pageRangeDisplayed={2}
              onPageChange={handlePaginate}
              containerClassName={'pagination'}
              activeClassName={'active'}
            />
          </Card.Footer>
        </Card>
      </Page.Content>
    </SiteWrapper>
  );
}

export default CashbackStatementsList;